<div class="row mb-3">
    <div class="col">
        <label class="col-form-label" [for]="id" [attr.aria-label]="'F4M_TEXT_INPUT_ARIA_LABEL' | translate">{{
            label
        }}</label>
        <div class="input-group">
            <input
                type="text"
                class="form-control input-md value-input"
                [id]="id"
                [(ngModel)]="value"
                (ngModelChange)="onChanged($event)"
                (blur)="onTouched()"
                [disabled]="disabled"
                [placeholder]="inputPlaceholder"
            />
            <span *ngIf="showScanner" class="input-group-text pb-0" id="addon-wrapping" (click)="openScanner()">
                <fa-icon [icon]="faBarcode" class="fs-4" size="1x"></fa-icon
            ></span>
        </div>
    </div>
</div>
